<template>
    <v-dialog
        v-model="$props.params.addUserUnderCategoryDialog"
        max-width="600px"
        transition="dialog-bottom-transition"
        @keydown.esc="closeAddUserUnderCategoryDialog()"
        @click:outside="closeAddUserUnderCategoryDialog()"
    >
        <v-form @submit.prevent="processAddUserUnderCategory()">

            <v-card>
                <v-toolbar
                    :class="dialogHeadingClasses()"
                    color="primary"
                    dark
                >
                    <v-icon class="mr-3" v-text="icons.mdiAccountPlus"></v-icon>
                    <span class="text-truncate"
                          v-text="$gettextInterpolate($gettext('Add a user for %{userGroup}'), {userGroup: capitalize($props.params.categoryKey) })"></span>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" v-text="icons.mdiClose"
                            @click.native.stop="closeAddUserUnderCategoryDialog()"></v-icon>
                    <v-icon v-text="icons.mdiContentSave" @click.native.stop="processAddUserUnderCategory()"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-8">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="userName"
                                    :error-messages="addUserErrors"
                                    :label="$gettext('Add user')"
                                    :placeholder="$gettext('Add user')"
                                    autofocus
                                    clearable
                                    outlined
                                    required
                                    @blur="$v.userName.$touch()"
                                    @input="$v.userName.$touch()"
                                ></v-text-field>

                                <!------------------------------------------------
                                    Login & Password are optional field as of now
                                ------------------------------------------------->

                                <v-text-field
                                    v-model="login"
                                    :label="$gettext('Login')"
                                    :placeholder="$gettext('Login')"
                                    clearable
                                    outlined

                                ></v-text-field>
                                <v-text-field
                                    v-model="password"
                                    :label="$gettext('Password')"
                                    :placeholder="$gettext('Password')"
                                    clearable
                                    outlined

                                ></v-text-field>

                                <v-select
                                    v-model="profile"
                                    :label="$gettext('Categories Profile')"
                                    :placeholder="$gettext('Categories Profile')"
                                    outlined
                                    :error-messages="addProfileErrors"
                                    @input="$v.profile.$touch()"
                                    @blur="$v.profile.$touch()"
                                    :items="profiles"
                                    item-text="profile_name"
                                    item-value="profile_name"
                                >
                                </v-select>

                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click.native.stop="closeAddUserUnderCategoryDialog()">
                        {{ $gettext('Close') }}
                    </v-btn>
                    <v-btn class="primary" type="submit">
                        {{ $gettext('Save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import Vue from 'vue'
import {find, findIndex, isArray, size} from 'lodash'

import Vuelidate from 'vuelidate'
import {required, minLength, maxLength, between} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import {mapState} from "pinia";
import {useCategoriesStore} from "@/stores/CategoriesStore";

Vue.use(Vuelidate)

export default {
    components: {Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigUsers, MixinVuelidate],
    props: {
        params: {
            required: true,
            type: Object,
        },
    },

    mounted() {
        let self = this
    },
    data() {
        return {
            userName: '',
            login: '',
            password: '',
            profile: '',
        }
    },

    methods: {

        capitalize(text) {
            return this.$options.filters.capitalize(text)
        },

        processAddUserUnderCategory() {

            let self = this

            self.$v.$touch()

            if (!self.$v.$invalid) {

                self.$parent.addUserUnderCategoryToDatabase(self.$props.params.categoryKey, {
                    key: self.userName,
                    value: {
                        devices: [],
                        login: self.login,
                        password: self.password,
                        'categories_profile': self.profile,
                        account_type: 'personal'
                    }
                })

                self.$parent.$refs.snackbar.showSnackbar(self.$gettext('User added successfully'))

                let categoryIndex = findIndex(self.$parent.users, {key: self.$props.params.categoryKey})
                let categoryElement = find(self.$parent.users, {key: self.$props.params.categoryKey})

                if (categoryIndex !== -1) {
                    self.$parent.categoryPanel = categoryIndex
                    self.$parent.userPanel = {[self.userName]: 0}
                }

                self.$parent.openAddEditDeviceDialog(self.$props.params.categoryKey, self.userName, 'add')
                self.closeAddUserUnderCategoryDialog()

            }

        },

        closeAddUserUnderCategoryDialog() {
            let self = this
            self.$parent.closeDialog('addUserUnderCategoryDialog')
        },
        resetForm() {
            let self = this
            self.$v.$reset()
            self.userName = ''
        },
    },
    computed: {

        addUserErrors() {
            const errors = []
            if (!this.$v.userName.$dirty) return errors
            !this.$v.userName.required && errors.push(this.$gettext('User\'s name is required.'))
            !this.$v.userName.isUnique && errors.push(this.$gettext('Sorry! It appears we already have this user name in use.'))
            return errors
        },

        addProfileErrors () {

            const errors = []
            if ( ! this.$v.profile.$dirty) return errors
            ! this.$v.profile.required && errors.push(this.$gettext('Categories profile is required'));
            return errors

        },

        ...mapState(useCategoriesStore,
            { profiles: 'profiles' }
        )

    },
    validations: {
        userName: {
            required,
            isUnique(value, vm) {

                if (isArray(this.consolidatedUsersAndSubUsers) && this.consolidatedUsersAndSubUsers.length > 0) {
                    return (findIndex(this.consolidatedUsersAndSubUsers, (user) => user.toLowerCase() === value.toLowerCase()) === -1)
                }
                return true

            }
        },
        profile: {
            required,
        }
    }
}
</script>
